<section class="agpr-agentHistory">
    <div class="agpr-agentHistory-container">
        @for (backfill of backfillDisplays; track backfill; let i = $index) {
            <div class="agpr-agentHistory-section">
                <!-- left section -->
                <div class="agpr-agentHistory-section-left">
                    <agpr-attribute-list
                        [attributes]="backfill.attributes"
                    ></agpr-attribute-list>
                </div>

                <!-- right section -->
                <div class="agpr-agentHistory-section-right">
                    <dl class="agpr-definitionList ui-g">
                        <dt class="agpr-definitionList-definitionTitle agpr-definitionList-mainTitle ui-g-12">
                            {{  'Social.agentWidget.query' | localize }}
                        </dt>
                        <div class="agpr-agentHistory-content">
                            <dt class="agpr-definitionList-definitionTitle ui-g-12">
                                {{ 'Social.agentWidget.networks' | localize }}
                            </dt>
                            @if (backfill.backfill.queryFields?.mediaTypes?.length > 0) {
                            <dd class="agpr-definitionList-definition">
                                <span *ngFor="let mediaType of backfill.backfill.queryFields.mediaTypes; let lastMediaType = last;">
                                    @if (!lastMediaType) {
                                    <ng-container *ngIf="!lastMediaType"> {{ ('Social.network.' + mediaType | localize) + ', ' }} </ng-container>
                                    } @else {
                                    <ng-container *ngIf="lastMediaType"> {{ ('Social.network.' + mediaType | localize) }} </ng-container>
                                    }
                                </span>
                            </dd>
                            }

                            <dt class="agpr-definitionList-definitionTitle ui-g-12">
                                {{ 'Keywords' | localize }}
                            </dt>
                            <dd class="agpr-definitionList-definition">
                                <agpr-keyword-group-summary
                                    [keywordGroup]="backfill.backfill.queryFields"
                                ></agpr-keyword-group-summary>
                            </dd>

                            @if (backfill.backfill.queryFields?.handles) {
                                <dt class="agpr-definitionList-definitionTitle ui-g-12">
                                    {{ 'Handles' | localize }}
                                </dt>
                                <dd class="agpr-definitionList-definition">
                                    <ng-container *ngIf="backfill.backfill.queryFields.handles?.length > 0">
                                        <span class="agpr-definitionList-definitionTitle ui-g-12 agpr-agentHistory-handleList-name">
                                            {{ 'MediaType.'+ mediaTypeEnum.TWITTER | localize }}
                                        </span>
                                        <div>
                                            <span *ngFor="let handle of backfill.backfill.queryFields.handles; let lastHandle = last;">
                                                <ng-container *ngIf="!lastHandle"> {{ handle + ', ' }} </ng-container>
                                                <ng-container *ngIf="lastHandle"> {{ handle}} </ng-container>
                                            </span>
                                        </div>
                                    </ng-container>
                                </dd>
                            }
                        </div>
                    </dl>
                </div>

                <!-- icon -->
                <!-- fa-regular does not work well with ngclass, so use separate icons for now -->
                @if (backfill.backfill.status === backfillStatusApiEnum.completed) {
                    <span
                        role="img"
                        class="agpr-agentHistory-section-icon fa-regular fa-circle-check"
                        [agprTooltip]="'Social.agentWidget.replay.tooltipStatus.'+backfill.backfill.status"
                    ></span>
                } @else if (backfill.backfill.status === backfillStatusApiEnum.inProgress || backfill.backfill.status === backfillStatusApiEnum.standBy) {
                    <span
                        role="img"
                        class="agpr-agentHistory-section-icon fa-kit fa-agpr-in-progress"
                        [agprTooltip]="'Social.agentWidget.replay.tooltipStatus.'+backfill.backfill.status"
                    ></span>
                } @else if (backfill.backfill.status === backfillStatusApiEnum.failed) {
                    <span
                        role="img"
                        class="agpr-agentHistory-section-icon fa-regular fa-xmark"
                        [agprTooltip]="'Social.agentWidget.replay.tooltipStatus.'+backfill.backfill.status"
                    ></span>
                }
            </div>
        }
    </div>
</section>

@if (!backfillDisplays || !backfillDisplays?.length) {
    <agpr-message
        [severity]="messageSeverities.noContent"
    >
        <span> {{ 'Social.agentWidget.replay.history.noContent' | localize }} </span>
    </agpr-message>
}
